export const setHandleOnEnterHotKey = (onSuccess) => (e) => {
    if (!onSuccess) {
        return;
    }

    e.preventDefault();

    onSuccess(e);
};
